import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\"><path d=\"M1.572 10.178a3.1 3.1 0 0 1 2.186-.905H8a3.09 3.09 0 0 1 3.09 3.09v1.213a.667.667 0 0 1-1.332 0v-1.212A1.757 1.757 0 0 0 8 10.606H3.758A1.76 1.76 0 0 0 2 12.364v1.212a.667.667 0 1 1-1.333 0v-1.212c0-.82.325-1.606.905-2.186M12.849 5.03c.368 0 .666.299.666.667v3.636a.667.667 0 0 1-1.333 0V5.697c0-.368.298-.667.666-.667\"></path><path d=\"M10.364 7.515c0-.368.298-.667.666-.667h3.637a.667.667 0 0 1 0 1.334H11.03a.667.667 0 0 1-.666-.667M5.879 3.333a1.758 1.758 0 1 0 0 3.516 1.758 1.758 0 0 0 0-3.516M2.788 5.091a3.09 3.09 0 1 1 6.182 0 3.09 3.09 0 0 1-6.182 0\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })